const BASIC_DATA_FIELDS = `
  id
  status
  type
  offersDueDate
  offersReceivedDate
  pricingExpirationDate
  contractDurations
	contractEffectiveDates
  preferredContractDuration
  preferredContractEffectiveDate
  submissionDate
  hasFormularyPrice
  buyer {
    id
    name
    organizationType
  }
  category {
    id
    name
    type
    categorizationScheme {
      id
      name
    }
  }
  isOneLevelCategoryScheme
  submittedBy {
    emailAddress
  }
  spendDateRange {
    startDate
    endDate
  }
  customSpendDateRange {
    bounds
    selected
    hasCustomSpendDateRange
  }
  publishedDate
  isPublishable
  auditInfo {
    createdDate
  }
`;

export default BASIC_DATA_FIELDS;
